export const FormResponseStatuses = {
    Approved: "Approved",
    Pending: "Pending",
    Declined: "Declined",
} as const;

export const FormResponseStatusList = Object.values(FormResponseStatuses);

/** UI/API filter value for responses whose status is null or not set. */
export const FormResponseStatusFilterNone = "__none__";

export type FormResponseStatus = typeof FormResponseStatuses[keyof typeof FormResponseStatuses];
